import { onBeforeUnmount, onMounted, ref, toValue } from 'vue';

export default function useSidebarResize({
  sidebar_width,
  width_min = 300,
  width_max = 800,
  direction = 'left',
  onResize,
}) {
  const is_resizing = ref(false);
  const x_start = ref(0);
  const width_start = ref(0);

  const start_resize = (event) => {
    is_resizing.value = true;
    x_start.value = event.clientX;
    width_start.value = sidebar_width.value;
    event.preventDefault();
  };

  const handle_resize = (event) => {
    if (!is_resizing.value) return;
    const deltaX = event.clientX - x_start.value;
    const new_width = direction === 'left' ? width_start.value - deltaX : width_start.value + deltaX;
    onResize(Math.max(toValue(width_min), Math.min(toValue(width_max), new_width)));
  };

  const stop_resize = () => {
    if (is_resizing.value) {
      is_resizing.value = false;
      onResize(sidebar_width.value);
    }
  };

  onMounted(() => {
    document.addEventListener('mousemove', handle_resize);
    document.addEventListener('mouseup', stop_resize);
  });

  onBeforeUnmount(() => {
    document.removeEventListener('mousemove', handle_resize);
    document.removeEventListener('mouseup', stop_resize);
  });

  return { is_resizing, start_resize };
}
